import { useEffect, useState } from "react";

export function useNow() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(t);
  }, []);
  return now;
}

export const MO_EN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MO_AR = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

export const sunPct = (sunrise, sunset, now) => {
  if (!sunrise || !sunset) return -1;
  const sr = new Date(sunrise).getTime();
  const ss = new Date(sunset).getTime();
  const p = (now.getTime() - sr) / (ss - sr);
  return Math.min(1, Math.max(0, p));
};

export const fmt12s = (iso) => {
  if (!iso) return "--:--";
  const d = new Date(iso), h = d.getHours(), h12 = ((h + 11) % 12) + 1;
  return `${h12}:${String(d.getMinutes()).padStart(2, "0")}`;
};

export const formatTime12 = (now) => {
  const hr = now.getHours(), h12 = ((hr + 11) % 12) + 1;
  return { h12, mm: String(now.getMinutes()).padStart(2, "0"), ampm: hr >= 12 ? "PM" : "AM" };
};

export const getWeatherAlert = (w, lang) => {
  if (!w) return null;
  const ar = lang === "ar";
  if (w.temp >= 42 || w.feels >= 45) return { icon: "🔥", text: ar ? "حرارة شديدة — اشرب ماءً وابقَ في الظل" : "Extreme heat — hydrate & stay cool", tone: "bg-red-500/90" };
  if (w.uv >= 8) return { icon: "☀️", text: ar ? "أشعة UV مرتفعة جداً — احمل واقي شمس ونظارة" : "Very high UV — wear sunscreen & shades", tone: "bg-orange-500/90" };
  if (w.humidity >= 75) return { icon: "💧", text: ar ? "رطوبة عالية — توقّع تعرّق مستمر" : "High humidity — expect sweat", tone: "bg-sky-500/90" };
  if (w.wind >= 40) return { icon: "💨", text: ar ? "رياح شديدة اليوم — تجنّب المناطق المكشوفة" : "Strong winds today — avoid open areas", tone: "bg-slate-500/90" };
  return null;
};
